export default {
  defaultProps: {
    underline: "none",
    color: "inherit",
  },
} as any;
